const CguCgv = () => import('@/views/TermsOfService')

export default [
	{
		component: CguCgv,
		name: 'cgu-cgv',
		path: 'cgu-cgv'
	}
]
